
import * as crud from '@/api/crud'
import { system_user_url, logout_url } from '@/utils/const'
import router, { resetRouter } from '@/router'

const state = {
  roleName: '',
  showPasswordHint: false,
  avatar: require('@/assets/logo.png'),
  permissionCodeList: [],
  menuRouteLoaded: false
}

const mutations = {
  SET_MENUROUTELOADED: (state, menuRouteLoaded) => {
    state.menuRouteLoaded = menuRouteLoaded
  },
  SET_ROLENAME: (state, roleName) => {
    state.roleName = roleName
  },
  // showPasswordHint
  SET_SHOWPASSWORDHINT: (state, showPasswordHint) => {
    state.showPasswordHint = showPasswordHint
  },
  SET_PERMISSIONCODELIST: (state, permissionCodeList) => {
    state.permissionCodeList = permissionCodeList
  }
}

const actions = {
  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      crud.get(system_user_url, 'current/read').then((response) => {
        const { data } = response
        
        commit('SET_MENUROUTELOADED', true)

        commit('SET_ROLENAME', roleNames)

        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const { roleNames, permissionCodeList } = data


        // roles must be a non-empty array
        // if (!permissionCodeList || permissionCodeList.length <= 0) {
        //   reject('getInfo: permission must be a non-null array!')
        // }

        commit('SET_ROLENAME', roleNames)
        // 权限列表
        commit('SET_PERMISSIONCODELIST', permissionCodeList)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }, options = {}) {
    return new Promise((resolve, reject) => {
        commit('SET_ROLENAME', false)
        if (options.request !== false) {
          crud.get(logout_url, '').then(() => {
            // console.log(response)
          })
        }
        resetRouter()
        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, { root: true })
        resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const { roleName, permissionCodeList } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes',  {roleName, permissionCodeList}, { root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  },

  setShowPasswordHint({ commit }, showPasswordHint) {
    console.log(showPasswordHint)
    commit('SET_SHOWPASSWORDHINT', showPasswordHint)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
